// @flow

import * as kv from 'idb-keyval';

import {storageItemLoaded} from 'docs/data/storage/StorageReducer';

import type {Dispatcher} from 'docs/data';
import type {StorageEvent} from 'docs/data/storage/StorageReducer';

export const saveItem = (
  dispatch: Dispatcher<StorageEvent>,
  database: any,
) => async (key: string, value: any) => {
  if (database !== null) {
    await kv.set(key, value, database);
    dispatch(storageItemLoaded(key, value));
  }
};
